/**
 * @description 处理富文本图片显示问题
 * @param {string } content
 * @return {string}
 */
export function handRichtext(content) {
  return content.replace(
    /\<img/gi,
    `<img style='max-width:100% !important;object-fit:cover;'`
  );
}

/**
 *  将秒转换成时分秒的形式
 * @param {string} = [] |
 * @return {void} = [] |
 */
export function formToTime(times) {
  let second = times % 60;
  let minute = Math.floor((times % (1 * 60 * 60)) / (1 * 60));
  let hour = Math.floor(times / (1 * 60 * 60));
  // second = second < 10 ? `0${second}` : second;
  // minute = minute < 10 ? `0${minute}` : minute;
  // hour = hour < 10 ? `0${hour}` : hour;
  return `${hour}时${minute}分${second}秒`;
}

//
const openList = [];
export function openWindow(url) {
  if (openList.length == 0) {
    let item = window.open(url, "_blank");
    openList.push(item);
  } else {
    for (let el of openList) {
      el.close();
    }
    let item = window.open(url, "_blank");
    openList.push(item);
  }
}

export const hasDevMode = (fn) => {
  if (process.env.NODE_ENV == "development") {
    fn();
  }
};
